import React, { useState, useRef, useEffect } from 'react'
import Tabs, { TabsActions } from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'

const useStyles = makeStyles((theme: Theme) => {
  return {
    tab: {
      fontSize: '20px',
      fontWeight: 'bold',
      padding: theme.spacing(2, 0),
      marginRight: theme.spacing(5),
      textTransform: 'none',
      minWidth: 'auto',
      '& span': {
        alignItems: 'start',
      },
    },
    tabsWrapperForPrimers: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0, 5),
      border: `1px solid ${theme.palette.grey[500]}`,
      borderBottom: 'none',
    },
    tabsWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(0, 5),
    },
  }
})

enum Products {
  KicqstartPrimers = 'kicqstartPrimers',
}

interface ProductSearchProps {
  manualSearch: React.ReactElement
  uploadQueries: React.ReactElement
  productName?: string
}

const ProductSearchTab: React.FC<ProductSearchProps> = ({
  manualSearch,
  uploadQueries,
  productName,
}) => {
  const [tabValue, updateTabValue] = useState(0)
  const classes = useStyles()
  const ref = useRef<TabsActions>(null)
  useEffect(() => {
    setTimeout(() => ref?.current?.updateIndicator(), 3000)
  }, [])
  return (
    <div>
      <Tabs
        value={tabValue}
        onChange={(e, value) => updateTabValue(value)}
        className={
          productName === Products.KicqstartPrimers
            ? classes.tabsWrapperForPrimers
            : classes.tabsWrapper
        }
        action={ref}
      >
        <Tab
          label={
            <FormattedMessage {...messages.CONF_MANUAL_SEARCH_crisprgrna} />
          }
          className={classes.tab}
        />
        <Tab
          label={
            <FormattedMessage {...messages.CONF_UPLOAD_QUERIES_crisprgrna} />
          }
          className={classes.tab}
        />
      </Tabs>
      {tabValue === 0 && manualSearch}
      {tabValue === 1 && uploadQueries}
    </div>
  )
}

export default ProductSearchTab
